import _ from 'lodash';
import {
  getFavoritesForAccount,
  getFavoritesDetailsForAccount,
  createFavorite,
  deleteFavoritesForAccount,
} from 'helpers/AccountHelper';
import { isBrowserIE } from 'helpers/GlobalHelper';
import { isStaticRender } from 'helpers/ContentHelper';
import { getAnonymousFavoritesFromStorage, getCurrentAccount } from 'helpers/AnonymousHelper';

async function getProfileSDK() {
  let ProfileSDK = null;
  if (isBrowserIE() || isStaticRender()) {
    return null;
  }
  ProfileSDK = await import('@foxcorp/foxkit-profile-js');
  return ProfileSDK;
}

export async function getFavorites() {
  const { profileConfig } = this.props;
  const ProfileSDK = await getProfileSDK();
  let profileFavorites = {};
  if (ProfileSDK) {
    profileFavorites = new ProfileSDK.ProfileFavorites(profileConfig);
  }

  const favorites = await profileFavorites.get();

  this.setAppFavorites({ favorites });
  this.getFavoritesDetails(favorites);
}

// TODO remove this! This IE is temporary til IE is sunset
export async function getFavoritesIE() {
  const { isLoadingFavorites } = this.state;
  const { account, anonymousAccount } = this.props;
  const currentAccount = account || anonymousAccount;
  if (!isLoadingFavorites && !currentAccount) {
    const anonymousFavorites = getAnonymousFavoritesFromStorage() || [];
    this.setAppFavorites({ favorites: anonymousFavorites, isLoadingFavorites: false });
    return;
  }
  if (!currentAccount || isLoadingFavorites) return;

  this.setState({ isLoadingFavorites: true });
  let favorites = await getFavoritesForAccount(currentAccount);

  if (!favorites || !_.isArray(favorites)) favorites = [];

  this.setAppFavorites({ favorites, isLoadingFavorites: false });
  this.getFavoritesDetails(favorites);
}

export async function getFavoritesDetails(initalFavorites) {
  const { isLoadingFavorites } = this.state;
  const { account, anonymousAccount } = this.props;
  const currentAccount = account || anonymousAccount;

  if (!currentAccount || isLoadingFavorites) return;

  this.setState({ isLoadingFavorites: true });
  let favorites = initalFavorites || (await getFavoritesForAccount(currentAccount));
  if (!favorites || !_.isArray(favorites)) favorites = [];
  const favoritesDetails = await getFavoritesDetailsForAccount(currentAccount, favorites);
  this.setAppFavorites({ favorites, favoritesDetails, isLoadingFavorites: false });
}

const formatFavorite = favoritableItems => {
  const formattedFavorites = _.map(favoritableItems, item => ({
    favoriteID: item.id,
    favoriteType: item['@type'],
  }));
  return formattedFavorites;
};

export async function setFavorites(favorite) {
  const { favorites } = this.state;
  const { account, anonymousAccount, deviceId, profileConfig } = this.props;
  const ProfileSDK = await getProfileSDK();
  let profileFavorites = {};
  if (ProfileSDK) {
    profileFavorites = new ProfileSDK.ProfileFavorites(profileConfig);
  }
  return new Promise(async resolve => {
    const currentAccount = await getCurrentAccount({
      account,
      anonymousAccount,
      anonymousLogin: this.anonymousLogin,
      deviceId,
    });
    const result = await createFavorite(currentAccount, favorite, profileFavorites);
    const { favoritableItems } = favorite;
    const formattedFavorites = formatFavorite(favoritableItems);

    if (favorites) favorites.push(...formattedFavorites);
    const newFavorites = favorites || formattedFavorites;
    this.setAppFavorites({ favorites: newFavorites });
    resolve(result);
  });
}

export async function deleteFavorites(favorite) {
  const { favoritableItems, showID } = favorite;
  const { favorites } = this.state;
  const { account, anonymousAccount, deviceId, profileConfig } = this.props;
  const ProfileSDK = await getProfileSDK();
  let profileFavorites = {};
  if (ProfileSDK) {
    profileFavorites = new ProfileSDK.ProfileFavorites(profileConfig);
  }
  return new Promise(async resolve => {
    const currentAccount = await getCurrentAccount({
      account,
      anonymousAccount,
      anonymousLogin: this.anonymousLogin,
      deviceId,
    });
    const result = await deleteFavoritesForAccount(currentAccount, favorite, profileFavorites);

    let newFavorites = [];

    favoritableItems.forEach(item => {
      const filteredFavorites = favorites.filter(f => f.favoriteID !== item.id);
      newFavorites = [...newFavorites, ...filteredFavorites];
    });

    if (showID) {
      favoritableItems.forEach(item => {
        const filteredFavorites = favorites.filter(f => f.favoriteID !== favorite.showID);
        newFavorites = [...filteredFavorites];
      });
    }

    this.setAppFavorites({ favorites: newFavorites });
    resolve(result);
  });
}

export function setAppFavorites({ favorites, favoritesDetails, isLoadingFavorites }) {
  const newState = {};

  if (favorites !== undefined && favorites !== this.state.favorites) {
    newState.favorites = favorites;
  }

  if (favoritesDetails !== undefined && favoritesDetails !== this.state.favoritesDetails) {
    newState.favoritesDetails = favoritesDetails;
  }

  if (isLoadingFavorites !== undefined && this.state.isLoadingFavorites) {
    newState.isLoadingFavorites = isLoadingFavorites;
  }

  if (newState.favorites || newState.favoritesDetails || newState.isLoadingFavorites) {
    this.setState(newState);
  }
}
